import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { FC } from 'react';

import { Aircraft } from 'domain/entities/Aircraft';
import { Entity } from 'domain/types/Entity';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { Modal } from 'targets/web/components';

interface DuplicateRegistrationWarningDialogProps {
  open: boolean;
  duplicates: Entity<Aircraft>[];
  onCancel: () => void;
  onProceed: () => void;
}

export const DuplicateRegistrationWarningDialog: FC<DuplicateRegistrationWarningDialogProps> = ({
  open,
  duplicates,
  onCancel,
  onProceed,
}) => {
  const t = useTranslationPrefix('configuration.aircraft.modal');

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={t('duplicate_warning_title')}
      description={t('duplicate_warning_body')}
      maxWidth="sm"
      fullWidth
      content={
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('label_type')}</TableCell>
              <TableCell>{t('label_reg')}</TableCell>
              <TableCell>{t('label_serial')}</TableCell>
              <TableCell>{t('col_status')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {duplicates.map((a) => (
              <TableRow key={a.id}>
                <TableCell>{a.type.name}</TableCell>
                <TableCell>{a.code}</TableCell>
                <TableCell>{a.serialNumber ?? '—'}</TableCell>
                <TableCell>
                  <Typography variant="body2" color={a.isActive ? 'success.main' : 'text.disabled'}>
                    {a.isActive ? t('status_active') : t('status_inactive')}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      }
      actions={{
        primary: {
          text: t('btn_proceed'),
          onClick: onProceed,
        },
        secondary: {
          text: t('btn_cancel'),
          onClick: onCancel,
        },
      }}
    />
  );
};
